<template>
    <b-modal v-model="localShow" centered hide-footer hide-header>
        <b-row align-h="around">
            <b-col align-self="end" cols="10"></b-col>
            <b-col align-self="end" cols="2">
                <img @click="localShow = false" class="close" src="@/assets/images/mood-pulse/close.svg" />
            </b-col>
        </b-row>
        <b-container fluid>
            <b-row class="pb-2" align-h="start">
                <p class="title">
                    {{ $t('moodPulse.report.exportTitle') }}
                </p>
            </b-row>
            <b-row align-h="start">
                <p class="text">
                    {{ $t('moodPulse.report.exportText') }}
                </p>
            </b-row>
            <b-row align-v="center">
                <b-col cols="12">
                    <v-date-picker v-model="range" mode="date" is-range>
                        <template v-slot="{ inputValue, inputEvents }">
                            <b-row align-v="center">
                                <b-col class="pl-0" cols="6">
                                    <b-form-input
                                        :placeholder="$t('moodPulse.report.initialDatePlaceholder')"
                                        style="width: 100%"
                                        :value="inputValue.start"
                                        v-on="inputEvents.start"
                                        @change="range.start = inputValue.start"
                                    />
                                </b-col>
                                <b-col cols="6">
                                    <b-form-input
                                        :placeholder="$t('moodPulse.report.finalDatePlaceholder')"
                                        style="width: 100%"
                                        :value="inputValue.end"
                                        v-on="inputEvents.end"
                                        @change="range.end = inputValue.end"
                                    />
                                </b-col>
                            </b-row>
                        </template>
                    </v-date-picker>
                </b-col>
            </b-row>
            <b-row class="pb-2 pt-3" align-h="center" v-if="this.isExporting">
                <i class="fa fa-spinner fa-spin px-2"></i>
            </b-row>
            <b-row class="pb-2 pt-3" align-h="center">
                <b-button @click="localShow = false" variant="outline-primary" class="mr-3 small-btn">
                    {{ $t('moodPulse.pauseModal.cancelBtn') }}
                </b-button>
                <b-button @click="exportToEmail" variant="primary" class="small-btn" :disabled="disableExport">
                    {{ $t('moodPulse.report.exportBtn') }}
                </b-button>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
import { setupCalendar, DatePicker as VDatePicker } from 'v-calendar'
import i18n from '@/i18n'
import { exportReport } from '../../api'
import moment from 'moment'
import notification, { success, danger } from '@/lib/notification'

notification.init()

setupCalendar({
    locale: i18n.locale,
    navVisibility: 'focus',
    popoverDirection: 'bottom',
    popoverVisibility: 'focus',
    popoverAlign: 'right',
})

export default {
    components: { VDatePicker },
    data() {
        return {
            isExporting: false,
            range: {
                start: null,
                end: null,
            },
        }
    },
    props: {
        show: {
            required: true,
            type: Boolean,
        },
        quizId: {
            required: true,
        },
    },
    computed: {
        localShow: {
            get() {
                return this.show
            },
            set(localShow) {
                this.$emit('click', localShow)
            },
        },
        disableExport() {
            return !this.range.start || !this.range.end
        },
    },
    methods: {
        exportToEmail() {
            let start = this.range.start ? moment(this.range.start).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')

            let end = this.range.end ? moment(this.range.end).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')

            this.isExporting = true

            exportReport(this.quizId, start, end)
                .then(() => success(this.$t('moodPulse.report.exportSuccess')))
                .catch(() => danger())
                .finally(() => {
                    ;(this.isExporting = false), (this.localShow = false)
                })
        },
    },
}
</script>

<style scoped>
.title {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 21px;
    color: #3b3f4e;
}

.text {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #3b3f4e;
}

.small-btn {
    border-radius: 5px;
    width: 84px;
    height: 25px;
    padding: 0;
}
</style>
